import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Search } from 'lucide-react';
import PublicLayout from '../../components/layout/PublicLayout';
import SEO from '../../components/SEO';
import toast from 'react-hot-toast';

const TrackTicket = () => {
  const [ticketNumber, setTicketNumber] = useState('');
  const navigate = useNavigate();

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!ticketNumber.trim()) {
      toast.error('Please enter a ticket number');
      return;
    }
    // Just navigate to the detail page, it will handle fetching and 404s
    navigate(`/support/ticket/${ticketNumber.trim().toUpperCase()}`);
  };

  return (
    <PublicLayout>
      <SEO title="Track Ticket | Retiring Room" description="Check the status of your support ticket." />
      
      <div className="min-h-screen bg-midnight-50 py-20">
        <div className="max-w-md mx-auto px-4">
          <div className="card p-8 text-center">
            <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-6">
              <Search className="w-8 h-8 text-blue-600" />
            </div>
            
            <h1 className="text-2xl font-display font-bold text-midnight-900 mb-2">Track Your Ticket</h1>
            <p className="text-midnight-500 mb-8">Enter your ticket number to view its status and updates.</p>
            
            <form onSubmit={handleSubmit} className="space-y-6">
              <div>
                <input 
                  type="text" 
                  value={ticketNumber}
                  onChange={(e) => setTicketNumber(e.target.value)}
                  placeholder="e.g. TKT-20250715-0001"
                  className="input-field text-center font-mono text-lg"
                  required
                />
              </div>
              
              <button type="submit" className="btn-primary w-full flex justify-center items-center gap-2">
                <Search className="w-4 h-4" />
                Track Ticket
              </button>
            </form>
          </div>
        </div>
      </div>
    </PublicLayout>
  );
};

export default TrackTicket;
